import React from "react";

const Tech = ({ tech }) => {
  return (
    <div className="lg:w-[56px] lg:h-[56px] w-[36px] h-[36px] relative flex justify-center items-center rounded-full bg-white shadow-lg hover:bg-[#147EFB] transition-all duration-500 hover:cursor-pointer group">
      <img src={tech.image} className="lg:w-9 md:w-9 w-6" alt={tech.name} />
      <p className="text-black absolute text-xs -top-4 hidden group-hover:flex font-bold">
        {tech.name}
      </p>
    </div>
  );
};

export default Tech;
